import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPhoneNumber]'
})
export class PhoneNumberDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    
    const inputElement = event.target as HTMLInputElement; // Ensure inputElement is typed correctly
    let inputValue = inputElement.value;

    // Allow only numbers and dashes
    const allowedInput = inputValue.replace(/[^0-9-]/g, '');

    // Ensure dashes are only in valid positions (4th and 8th)
    let formattedValue = allowedInput
      .replace(/-/g, '') // Remove all dashes temporarily
      .slice(0, 10); // Limit to 10 characters

    // Reinsert dashes at valid positions
    if (formattedValue.length > 3) {
      formattedValue = `${formattedValue.slice(0, 3)}-${formattedValue.slice(3)}`;
    }
    if (formattedValue.length > 7) {
      formattedValue = `${formattedValue.slice(0, 7)}-${formattedValue.slice(7)}`;
    }

    // Check if the user manually entered a dash at the 4th or 8th position
    const caretPosition = inputElement.selectionStart || 0;
    if (
      (caretPosition === 4 || caretPosition === 8) &&
      inputValue[caretPosition - 1] === '-' // Ensure a dash was entered
    ) {
      // Allow the dash to remain
      formattedValue = `${formattedValue.slice(0, caretPosition - 1)}-${formattedValue.slice(caretPosition - 1)}`;
    }

    // Update the input's displayed value
    inputElement.value = formattedValue;

  }
}
